import { footer } from "./footer";

export const site = {
    footer
}
